




























































































































import PayButton from './PayButton.vue'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciCredit } from '~/icons/source/solid/credit'
import { computed, defineComponent, toRefs } from '~/utils/nuxt3-migration'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useNamespacedStore } from '~/compositions/store'
import { ViewType } from '~/models/shared/types'
import { useDep } from '~/compositions/dependency-container'
import { ciCheckCircle } from '~/icons/source/solid/check-circle'
import { ciExclamationTriangle } from '~/icons/source/solid/exclamation-triangle'
import PaidClassifiedBadge from '~/components/car/classifieds/badges/PaidClassifiedBadge.vue'
import { PropType } from 'vue'
import { ClassifiedSearchResultRow } from '~/models/search/types'

export default defineComponent({
  components: {
    PaidClassifiedBadge,
    PayButton
  },
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { classified, viewType } = toRefs(props)

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const legacyUrlService = useDep(LegacyUrlService)

    const totalUserCredits = computed(() => userGetters('totalCredits'))

    const userIsAdmin = computed(() => userGetters('isAdmin'))

    const paidInfo = computed(() => classified.value.paidClassified)

    const hasEnoughCredits = computed(() => {
      const cost = paidInfo.value.remainingCostForToday
      return cost <= totalUserCredits.value
    })

    const isGallery = computed(() => viewType.value === ViewType.GALLERY)

    const isList = computed(() => viewType.value === ViewType.LIST)

    const isHidden = computed(() => {
      if (paidInfo.value) {
        return (
          !paidInfo.value.hasPaymentFailure &&
          !paidInfo.value.classifiedIsActive &&
          !paidInfo.value.isNonPublic
        )
      }
      return false
    })

    function handleChargesButtonClick() {
      window.location.assign(
        `/classifieds/${classified.value.id}/edit/charges/`
      )
    }

    function handleBuyCreditsButtonClick() {
      const buyCreditsUrl = legacyUrlService.getBuyCreditsUrl()

      window.location.assign(buyCreditsUrl)
    }

    return {
      hasEnoughCredits,
      isGallery,
      isList,
      isHidden,
      paidInfo,
      userIsAdmin,
      handleChargesButtonClick,
      handleBuyCreditsButtonClick,
      ciCredit,
      ciExclamationTriangle,
      ciCheckCircle
    }
  }
})
